import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import dayjs from 'dayjs';

const ExportButton = ({
    headers,
    page,
    prepareRow,
}) => {
    return (
        <Button size="sm" variant="outline-secondary" onClick={() => {
            try {
                const cols = headers || [];
                const headerNames = cols.map(c => (typeof c.Header === 'string' ? c.Header : (c.accessor || c.id || '')));

                const rows = (page || []).map(r => {
                    // ensure row is prepared so r.cells is populated
                    try { prepareRow && prepareRow(r); } catch (err) { console.err(err) }
                    return (r.cells || []).map(cell => {
                        const colType = cell?.column?.type;
                        let val = cell?.value;
                        switch (colType) {
                            case 'image':
                                return '';
                            case 'ccf-odr-link':
                                return val ?? '';
                            case 'date':
                                return val ? dayjs(val).format('DD/MM/YYYY') : '';
                            case 'datetime':
                                try { return val ? dayjs(val).format('DD/MM/YYYY HH:mm:ss') : ''; } catch { return String(val ?? ''); }
                            default:
                                if (val === null || val === undefined) return '';
                                if (typeof val === 'object') return JSON.stringify(val);
                                return String(val);
                        }
                    });
                });

                const csvContent = [headerNames, ...rows].map(e => e.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join('\n');
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'export.csv';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Export failed', err);
            }
        }}>Export to Excel</Button>
    );
};
ExportButton.propTypes = {
    headers: PropTypes.array,
    page: PropTypes.array,
    prepareRow: PropTypes.func,
};

export default ExportButton;
